import { HistoryCardBase } from './HistoryCardBase';
import { DocumentHistoryItemMX } from '@domains/documents-review/interfaces/interfaces';
import { CountryCode } from '@domains/country';

interface Props {
  item: DocumentHistoryItemMX;
  index: number;
}

const labels: Record<string, string> = {
  complex: 'Conjunto',
  property_type: 'Tipo de Inmueble',
  admin_price: 'Valor admin.',
  median_zone: 'Zona mediana',
  zip_code: 'Código postal',
  property_document_type: 'Tipo de documento para determinar el área',
  committee_price_area: 'Área precio comité',
  committee_land_area: 'Área terreno comité',
  committee_expansion_area: 'Comité área de ampliación',
  rooms: 'Recamaras',
  baths: 'Baños',
  floor: 'Piso',
  elevator: 'Elevador',
  has_garage_doc: 'Documento estacio.',
  garage: 'Estacionamiento',
  years_old: 'Antigüedad',
  comment: 'Comentario',
  accessory_areas: 'Áreas accesorias',
};

export const propertyDocumentTypeLabels: Record<string, string> = {
  deed: 'Escritura',
  appraisal: 'Avalúo',
  condominium_regime: 'Régimen en condominio',
  remodeling_measures: 'Medidas Remodelaciones',
  architectural_plan: 'Plano arquitectónico',
  property_tax_satellite_measurement: 'Boleta predial + medición satelital',
  lien_free_certificate: 'Certificado libre gravamen',
  construction_license: 'Licencia construcción',
  public_property_registry: 'Registro público de la propiedad',
};

export const propertyTypeLabels: Record<string, string> = {
  '1': 'Departamento en edificio',
  '2': 'Casa sola',
  '3': 'Casa en condominio',
  '5': 'Dúplex',
};

export const HistoryCardMX = ({ item, index }: Props) => (
  <HistoryCardBase
    item={item}
    index={index}
    labels={labels}
    country={CountryCode.MX}
  />
);
